import { useState } from "react";
import { ChatType } from "../../../services/apiTypes";
import UserIcon from "../../UserIcon";
import { InboxMessageContainer, LastMessage, LeftContainer, PurpleCircle, Username, UsernameContainer } from "./styles";

type InboxMessageProps = ChatType & {
  avatarUrl: string;
  onClick: () => void;
}

export default function InboxMessage({ avatarUrl, messages, name, onClick }: InboxMessageProps) {
  const [message, setMessage] = useState<string>(messages?.[messages.length - 1]?.content.slice(0, 25) + ((messages?.[messages.length - 1]?.content && messages?.[messages.length - 1]?.content.length > 25) ? '...' : '')) ?? '';

  const [isOnline, setIsOnline] = useState<boolean>(false);
  return (
    <InboxMessageContainer onClick={onClick}>
      <LeftContainer>
        <UserIcon isOnline={isOnline} icon={avatarUrl} size="m" />
        <UsernameContainer>
          <Username>{name}</Username>
          <LastMessage>{message}</LastMessage>
        </UsernameContainer>
      </LeftContainer>
      <PurpleCircle $isOnline={isOnline} />
    </InboxMessageContainer>
  );
}